export default __webpack_public_path__ + "static/media/image1.6d922919.png";